module Meevo.Plugins.PurchaseOrder {

    class PurchaseOrderNoteController {

        static $inject = [
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.tracking.TrackingService",
            "$mdDialog",
            "purchaseOrderId",
            "note"
        ];

        public isAdding: boolean;

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private $mdDialog,
            private purchaseOrderId: string,
            public note: any,
            private preventUsageTracking: boolean) { 

            if ((this.isAdding = !this.note)) {
                this.note = {
                    id: NewGuid(),
                    purchaseOrderId: this.purchaseOrderId,
                    objectstate: Model.ObjectStateEnum.Active,
                    note: ""
                };
            }

        }

        save(): any {
            if (this.isAdding) {
                return this.dataService.customMethodData("api/PurchaseOrder/" + this.purchaseOrderId + "/Note", "POST", this.note)
                    .then((response) => {
                        //audit log
                        if (!this.preventUsageTracking) {
                            this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrderNote, Model.VerbEnum.SaveButtonClicked, null, this.purchaseOrderId);
                        }
                        return this.closeDialog(this.note.note);
                    });
            }

            else {
                return this.dataService.customMethodData("api/PurchaseOrder/" + this.note.id + "/Note", "PUT", this.note)
                    .then((response) => {
                        //audit log
                        if (!this.preventUsageTracking) {
                            this.usageTrackingLog(Meevo.Model.NounEnum.PurchaseOrderNotes, Model.VerbEnum.SaveButtonClicked, null, this.purchaseOrderId);
                        }
                        return this.closeDialog(this.note.note);
                    });
            }
        }

        /*
        *   TRACKING 
        */
        usageTrackingLog(nounEnum, verbEnum, payload, mainEntityId): void {
            if (nounEnum !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, mainEntityId);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        closeDialog(noteText: any): any {
            return this.$mdDialog.hide(noteText);
        }

    }

    angular.module("meevo.plugins.purchaseOrder")
        .controller("meevo.plugins.purchaseOrder.PurchaseOrderNoteController", PurchaseOrderNoteController);
}